import { Typography } from "@mui/material";
import { Link } from "react-scroll";
import type { DrawerMenuItemProps } from "./types/DrawerMenuItemProps";

export function DrawerMenuItem({ navItem, onClose }: DrawerMenuItemProps) {
  return (
    <Link
      to={navItem.id}
      smooth
      offset={-100}
      duration={500}
      onClick={() => {
        onClose();
        window.history.pushState(null, "", `#${navItem.id}`);
      }}
      style={{ textDecoration: "none", width: "100%", display: "block" }}
    >
      <Typography
        sx={{
          px: 2,
          py: 1.5,
          borderRadius: 1,
          fontWeight: "bold",
          textTransform: "uppercase",
          cursor: "pointer",
          "&:hover": { backgroundColor: "rgba(0,0,0,0.08)" },
        }}
      >
        {navItem.title}
      </Typography>
    </Link>
  );
}
